// extracted by mini-css-extract-plugin
export default {"SignInBannerMessage-errorMessage":"SignInBannerMessage_SignInBannerMessage-errorMessage__XAT-2"};